export { default as modeGovernance } from './mode-governance.plugin';
